var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0067FF",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M37.728,49.312v186.48C37.728,413.104,256,512,256,512s218.272-98.896,218.272-276.208V49.312 C474.272,49.312,396.128,0,256,0S37.728,49.312,37.728,49.312z",
    style: {
      opacity: 0.1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C115.872,0,37.728,49.312,37.728,49.312v186.48C37.728,413.104,256,512,256,512V0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888"
    },
    d: "M364.6,286.992c0,0-29.104,74.104-108.6,74.104s-108.6-74.104-108.6-74.104 S256,361.096,364.6,286.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888"
    },
    d: "M224.8,153.424c-16.072-37.664-59.632-55.168-97.296-39.096 c-17.584,7.504-31.592,21.512-39.096,39.096H224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888"
    },
    d: "M423.592,153.424c-16.072-37.664-59.632-55.168-97.296-39.096 c-17.584,7.504-31.592,21.512-39.096,39.096H423.592z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCharacter);
export default __webpack_public_path__ + "static/media/icon-character.4989d93cf58db963d24566120a5dae27.svg";
export { ForwardRef as ReactComponent };